import $ from 'jquery';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

window.$ = $;
window.gsap = gsap;

gsap.registerPlugin(ScrollTrigger);

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduceMotion) {
    window.lenis = new Lenis();

    // keep GSAP's ScrollTrigger in sync with Lenis's smooth scroll
    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
}

//ScrollReveal / Inview
document.addEventListener("DOMContentLoaded", function(event) {
    const revealTargets = document.querySelectorAll('.element-werte .entries, .element-meilensteine .entries, .element-headerbild');

    if (!('IntersectionObserver' in window)) {
        revealTargets.forEach(el => el.classList.add('in-view'));
    } else {
        const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view');
                    revealObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2 });

        revealTargets.forEach(el => revealObserver.observe(el));
    }
});

// Accordion (element Werte)
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.element-werte .accordion').forEach(accordion => {
        const triggers = Array.from(accordion.querySelectorAll('.accordion-trigger'));

        accordion.classList.add('is-enhanced');

        const items = triggers.map(trigger => ({
            trigger,
            item: trigger.closest('.accordion-item'),
            panel: document.getElementById(trigger.getAttribute('aria-controls')),
        }));

        const collapse = ({ trigger, item, panel }) => {
            trigger.setAttribute('aria-expanded', 'false');
            item.classList.remove('is-open');
            panel.style.height = panel.scrollHeight + 'px';
            panel.getBoundingClientRect(); // reflow erzwingen
            panel.style.height = '0px';
            panel.inert = true;
        };

        const expand = ({ trigger, item, panel }) => {
            trigger.setAttribute('aria-expanded', 'true');
            item.classList.add('is-open');
            panel.inert = false;
            panel.style.height = panel.scrollHeight + 'px';

            if (parseFloat(getComputedStyle(panel).transitionDuration) === 0) {
                panel.style.height = 'auto';
                return;
            }

            panel.addEventListener('transitionend', function done(e) {
                if (e.propertyName !== 'height') return;
                panel.removeEventListener('transitionend', done);
                if (item.classList.contains('is-open')) panel.style.height = 'auto';
            });
        };

        items.forEach(entry => {
            entry.panel.style.height = '0px';
            entry.panel.inert = true;

            entry.trigger.addEventListener('click', () => {
                const isOpen = entry.trigger.getAttribute('aria-expanded') === 'true';

                if (isOpen) {
                    collapse(entry);
                    return;
                }

                items.forEach(other => {
                    if (other !== entry && other.item.classList.contains('is-open')) {
                        collapse(other);
                    }
                });
                expand(entry);
            });
        });
    });
});